import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEntryProceduresAddSchema = () =>
    z.object({
        id: requiredUuid(),
        entry_id: requiredUuid(),
        procedure_id: requiredUuid(),
        price: requiredString(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        user_id: requiredUuid(),
        name: requiredString(),
        quantity: requiredNumber(),
        organisation_id: requiredUuid(),
    });

export const createEntryProceduresUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEntryProceduresAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.entry_procedures,
    );

export const createEntryProceduresDeleteSchema = () => createDeleteSchema();

export const createEntryProceduresSchemas = () => ({
    add: createEntryProceduresAddSchema(),
    update: createEntryProceduresUpdateSchema(),
    delete: createEntryProceduresDeleteSchema(),
});
